// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { withAuthClockCheck } from '@/lib/authClockSkew';
import { guardStorageUploads } from '@/lib/storage/uploadLimits';

let SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
let SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  const mode = (import.meta.env as Record<string, string | undefined>).MODE;
  if (mode === 'test') {
    SUPABASE_URL = SUPABASE_URL ?? 'http://localhost';
    SUPABASE_ANON_KEY = SUPABASE_ANON_KEY ?? 'test_key';
  } else {
    throw new Error(
      'Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
    );
  }
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Every storage upload is size-checked against its bucket limit before any
// bytes are sent (src/lib/storage/uploadLimits.ts) — an oversized file gets a
// clear error locally instead of a 413 after a full upload.
export const supabase = guardStorageUploads(createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  global: { fetch: withAuthClockCheck(SUPABASE_URL, (...args) => fetch(...args)) },
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
}));